unit Reports.Donation.Utils;
interface

uses
  System.Generics.Collections,
  SMX.ReturnTypes,
  JS;

type

  TReportOutput = (roCSV, roExcel);
  TDonationReportUtils = class
  private
  public
    [Async]
    class procedure DonationReport(const SelectionField: string;
      const SelectionValue: string; const StartDate: TDate; const EndDate: TDate;
      const DateSelection: string; const OrderBy: string; const Output: TReportOutput); async;
    [Async]
    class function GetLookupPairs(const AFieldName: string): TList<TLookupPair>; async;
  end;

implementation

{ TDonationReportUtils }

uses
  System.SysUtils,
  MainDataModule,
  XData.Web.Client,
  Reports.Result.Utils;

class procedure TDonationReportUtils.DonationReport(const SelectionField, SelectionValue: string; const StartDate,
  EndDate: TDate; const DateSelection: string; const OrderBy: string; const Output: TReportOutput);
var
  lRetval: TXDataClientResponse;
begin
  lRetval := Await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IDonationReportsService.DonationReport',
    [SelectionField, SelectionValue, StartDate, EndDate, DateSelection, OrderBy, Output]));

  TReportResultUtils.HandleReportResult(TJSObject(lRetval.Result));
end;

class function TDonationReportUtils.GetLookupPairs(const AFieldName: string): TList<TLookupPair>;
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSArray;
  I: Integer;
begin
  Result := TList<TLookupPair>.Create;

  lRetval := Await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IDonationReportsService.GetLookupPairs',
    [AFieldName]));

  lResult := TJSArray(TJSObject(lRetval.Result)['value']);

  if lResult = nil then
    Exit;

  for I := 0 to lResult.Length - 1 do
    Result.Add(TLookupPair.Create(JS.toObject(lResult[I])));

end;

end.

